/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useRef } from 'react';
import ApexCharts, { ApexOptions } from 'apexcharts';
import { getCSS, getCSSVariableValue } from '../../../../assets/ts/_utils';
import { useThemeMode } from '../../../layout/theme-mode/ThemeModeProvider';
import { useIntl } from 'react-intl';
import { useAuth } from '../../../../../app/modules/auth';
import { getGuidanceSubfieldScatterChart } from '../../../../../app/modules/guidance/guidances-list/core/_requests';
import { ChartModel, initialChartModel } from '../../../../../_metronic/partials/widgets/charts/_models';
import { useYear } from '../../../../../_metronic/partials/layout/header-menus/YearsManager';
import { RoleModel } from '../../../../../app/modules/auth/core/_models';
import { useTerm } from '../../../layout/header-menus/TermsManager';

type Props = {
  className: string;
  unitId?: number
  customerId?:number
};

const GuidanceSubfieldScatterChart: React.FC<Props> = ({ className, unitId = undefined, customerId = undefined }) => {
  const [guidanceSubfieldScatterChart, setGuidanceSubfieldScatterChart] = useState<ChartModel | undefined>(initialChartModel);
  const [refreshOnce, setRefreshOnce] = useState<boolean>(true)
  const chartRef = useRef<HTMLDivElement | null>(null);
  const { mode } = useThemeMode();
  const intl = useIntl();
  const { currentUser, auth } = useAuth();
  const currentYearId = useYear();
  const currentTermId = useTerm();

  useEffect(() => {
    let query = '';
    if(auth?.currentRole === RoleModel.Admin)
      query = "&academicYearId=" + currentYearId;
    else if (auth?.currentRole === RoleModel.InstitutionManager)
      query = '&institutionId=' + currentUser?.institutionId + '&academicYearId=' + currentYearId + '&termId=' + currentTermId;
    else if (auth?.currentRole === RoleModel.Customer )
      query = '&customerId=' + currentUser?.customerId + '&academicYearId=' + currentYearId + '&termId=' + currentTermId;
    else if (auth?.currentRole === RoleModel.Person)
      query = '&personId=' + currentUser?.personId + '&academicYearId=' + currentYearId + '&termId=' + currentTermId;
    else
      query = '&institutionId=' + currentUser?.institutionId + '&subinstitutionId=' + currentUser?.subinstitutionId + '&academicYearId=' + currentYearId + '&termId=' + currentTermId + "&employeeId=" + currentUser!.employeeId + (unitId ? "&unitId=" + unitId : '') + (customerId ? "&customerId=" + customerId : '');

    getGuidanceSubfieldScatterChart(query).then((value) => {
      setGuidanceSubfieldScatterChart(value);
    });
    setTimeout(function () {
      setRefreshOnce(false)
    }, 150)
  }, [className, unitId, customerId]);

  const refreshMode = () => {
      if (!chartRef.current) {
        return
      }
      const height = parseInt(getCSS(chartRef.current, 'height'))
      const chart = new ApexCharts(chartRef.current, getChartOptions(height, guidanceSubfieldScatterChart))
  
      if (chart) {
        chart.render()
      }
  
      return chart
    }

  useEffect(() => {
    const chart = refreshMode()

    return () => {
      if (chart) {
        chart.destroy();
      }
    };
  }, [chartRef, mode, guidanceSubfieldScatterChart,refreshOnce]);

  function getChartOptions(height: number, GuidanceSubfieldScatterChart: ChartModel | undefined): ApexOptions {
    return {
      series: [
        {
          name: "",
          data: GuidanceSubfieldScatterChart?.series1 as Array<number>,
        },
      ],
      chart: {
        type: 'bar',
        height: 350,
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          horizontal: true,
          distributed: true,
          barHeight: '80%',
        },
      },
      colors: ['#F44F5E', '#E55A89', '#D863B1', '#CA6CD8', '#B57BED', '#8D95EB', '#62ACEA', '#4BC3E6'],
      dataLabels: {
        enabled: true,
          formatter: (val) => `${val}`, 
        dropShadow: {
          enabled: true,
        },
      },
      xaxis: {
        categories: GuidanceSubfieldScatterChart?.categories as Array<string>,
      },
      yaxis: {
        labels: {
          show: true,
        },
      },
      legend: {
        show: false,
      },
    };
  }

  return (
    <div className={`card ${className}`}>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>{intl.formatMessage({ id: '6fj' })}</span>
          <span className='text-muted fw-semibold fs-7'>{intl.formatMessage({ id: '6fk' })}</span>
        </h3>
      </div>
      <div className='card-body'>
        <div ref={chartRef} id='kt_charts_widget_3_chart' style={{ height: '350px' }}></div>
      </div>
    </div>
  );
};

export { GuidanceSubfieldScatterChart };
